<template>
    <div>
        <a-page-header title="Users">
            <template slot="extra">
                <a-button key="1" type="primary" @click="addNewUser()">Add New Sales
                </a-button>
            </template>
        </a-page-header>
        <data-table ref="usersDataTable" :columns="columns" :data-source="salesHandlerState.salesHandlers"
            :loading="loading" @refreshData="fetchData" rowKey="salesId">
            <span slot="action" slot-scope="record">
                <a class="edit-icon" @click="showEditModal(record.salesId)">
                    <a-icon type="edit" />
                </a>
                <a-divider type="vertical" />
                <a class="trash-icon" @click="confirmDelete(record.salesId)">
                    <a-icon type="delete" />
                </a>
            </span>
        </data-table>
        <EditSalesModal v-model="isEditUserModalVisible" :Sales="editedUser"></EditSalesModal>
        <NewSalesModal v-model="isNewUserModalVisible" :Sales="newUser"></NewSalesModal>
    </div>
</template>

<script>
import { salesHandlerState, salesHandlerMutations } from "../../Store/store";
import EditSalesModal from "./EditSalesModal";
import NewSalesModal from "./NewSalesModal";

const columns = [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: true,
        width: 150,
    },
    {
        title: "Surname",
        dataIndex: "surname",
        key: "surname",
        sorter: true,
        width: 150,
    },
    {
        title: "Initial",
        dataIndex: "initial",
        key: "initial",
        sorter: true,
        width: 50,
    },
    {
        title: "Email Address",
        dataIndex: "emailAddress",
        key: "emailAddress",
        sorter: true,
        width: 150,
    },
    {
        title: "Actions",
        key: "action",
        scopedSlots: { customRender: "action" },
        width: 70,
    },
];

export default {
    data() {
        return {
            columns,
            isEditUserModalVisible: false,
            isNewUserModalVisible: false,
            businesses: [],
            editedUser: {},
            newUser: {},
            salesHandlerState: salesHandlerState,
            loading: false,
        };
    },
    async mounted() {
        await this.fetchData();
    },
    methods: {
        async fetchData(params = {}) {
            this.loading = true;

            try {
                await salesHandlerMutations.getSales(params);
            } finally {
                this.loading = false;
            }
        },
        confirmDelete(userId) {
            const self = this;
            this.$confirm({
                title: "Please beware!",
                content: "Are you sure about deleting this sales?",
                okText: "Delete",
                okType: "danger",
                maskClosable: true,
                cancelText: "Cancel",
                async onOk() {
                    const { salesId } = self.salesHandlerState.salesHandlers.find((u) => u.salesId === userId);
                    try {
                        let res = await salesHandlerMutations.deleteSales(salesId);
                        self.$refs.usersDataTable.refreshData(true);
                        if (res?.success) {
                           self.showSuccess(res?.result?.message);
                        }
                    } catch (error) {
                        self.showError(error.response?.data?.errors[0].errorMessage ?? error.message);
                    }

                },
            });
        },
        addNewUser() {
            this.newUser = {};
            this.isNewUserModalVisible = true;
        },
        showEditModal(userId) {
            this.editedUser = {
                ...this.salesHandlerState.salesHandlers.find((i) => i.salesId == userId),
            };
            this.isEditUserModalVisible = true;
        },
    },
    components: {
        EditSalesModal,
        NewSalesModal,
    },
};
</script>

<style scoped>
.trash-icon:hover {
    color: #bb2020;
}

.edit-icon:hover {
    color: #121317;
}
</style>
